import React, { useEffect, useMemo, useState } from 'react';
import Classes from './Notes.module.css';
import MessageItem from './MessageItem';
import backend from '../../../../../../../../../api';
import { useSelector } from 'react-redux';

export default function Notes({ booking, refresh }) {
  const { user, token } = useSelector(s => s?.auth || {});
  const [text, setText] = useState("");
  const notes = useMemo(() => booking?.notes || [], [booking]);

  const handleAdd = async () => {
    const v = text.trim();
    if (!v || !booking?._id) return;
    try {
      const { data } = await backend.post(
        `/api/bookings/${booking._id}/notes`,
        { text: v, byUserId: user?._id },
        { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
      );
      setText("");
      refresh?.();
    } catch (e) {
      alert(e?.response?.data?.error || e.message);
    }
  };

  return (
    <div className={Classes.main}>
      <div className={Classes.left}>
        <div className={`${Classes.messages} scroll`}>
          {notes.length === 0 ? (
            <h5 className='placeholderText' style={{ margin: '0' }} >No notes yet.</h5>
          ) : (
            notes.slice().reverse().map((n, idx) => (
              <MessageItem
                key={n._id || idx}
                index={idx}
                name={n?.by?.name || [n?.by?.firstName, n?.by?.lastName].filter(Boolean).join(" ") || "Admin"}
                time={new Date(n.at).toLocaleString()}
                message={n.text}
              />
            ))
          )}
        </div>

        <div style={{ position: 'relative' }}>
          <div className={Classes.whiteFade}></div>
        </div>

        <div className={Classes.commentBox}>
          <input
            type="text"
            placeholder="Add a note"
            value={text}
            onChange={e => setText(e.target.value)}
            onKeyDown={(e) => (e.key === "Enter" ? handleAdd() : null)}
          />
          <button type="button" onClick={handleAdd}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="rgba(223, 135, 91, 1)" height='17px' viewBox="0 0 512 512">
              <path d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
